import {Component, signal, ChangeDetectionStrategy} from "@angular/core"
import {MatInputModule} from "@angular/material/input"
import {MatSelectModule} from "@angular/material/select"
import {ButtonComponent} from "@app/common/components/buttons/button/button.component"
import {RoutedDialogComponent} from "@app/common/components/dialogs/routed-dialog/routed-dialog.component"
import {DialogSize} from "@app/common/models/dialogs"
import {ConfiguratorTestIframeComponent} from "@app/test/manual-testing/configurator-test-iframe/configurator-test-iframe.component"
import {ConfiguratorTestWCComponent} from "@app/test/manual-testing/configurator-test-webcomponent/configurator-test-wc.component"
import {CustomerPagesTestComponent} from "@app/test/manual-testing/customer-pages-test/customer-pages-test.component"
import {Source, sourceSchema} from "@app/test/manual-testing/types/types"
import {MatTooltipModule} from "@angular/material/tooltip"
import {BdcloudTestComponent} from "@app/test/manual-testing/bdcloud-test/bdcloud-test.component"
import {MaterialDownloadTestComponent} from "@app/test/manual-testing/material-download/material-download.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-test-base",
    imports: [
        RoutedDialogComponent,
        ButtonComponent,
        ConfiguratorTestIframeComponent,
        ConfiguratorTestWCComponent,
        MatTooltipModule,
        MatInputModule,
        MatSelectModule,
        MaterialDownloadTestComponent,
        BdcloudTestComponent,
        CustomerPagesTestComponent,
    ],
    templateUrl: "./test-base.component.html",
    styleUrl: "./test-base.component.scss",
})
export class TestBaseComponent {
    dialogSizes = DialogSize
    readonly $sources = signal(sourceSchema.options)

    readonly $viewType = signal<"ConfiguratorIframe" | "ConfiguratorWebcomponents" | "MaterialDownload" | "BdCloud" | "CustomerPages">("ConfiguratorIframe")
    readonly $source = signal<Source>("local")
}
